import { fabricateRows } from '../actions/ability-preconditions';
import { fromBaseRecord } from '../compile/from-base-context';
import { mergeInventoryMetadata } from '../compile/inventory-shared-catalog';
import type { InventoryTemplateSources } from './compose-size-template';
import { inventoryCreationSizeTemplateIds } from './creation-size-template';
import type { Row } from '../spawn/row-plan';

export function inventoryYieldTemplateSources(encounter: Row): InventoryTemplateSources {
    const source = fromBaseRecord(encounter.inventory_yield_templates) ? encounter.inventory_yield_templates : {};
    return { enchantment_templates: Array.isArray(source.enchantment_templates) ? source.enchantment_templates : [],
        enchantment_template_enchantments: Array.isArray(source.enchantment_template_enchantments) ? source.enchantment_template_enchantments : [] };
}

/** Raw SELECT adoption precedes preflight/draws; the closure includes saved signature candidates. */
export async function hydrateInventoryYieldTemplates(encounter: Row, abilities: readonly Row[],
    entries: (row: Row, key: string) => unknown[], fetcher: typeof fetch): Promise<void> {
    const selected = [...new Set(abilities.flatMap(ability => fabricateRows(entries(ability, 'fabricate')).map(row => row.template)).filter(Boolean))];
    if (!selected.length) return;
    const response = await fetcher(BASE_URL + 'options/api/spawn_inputs_inc.php', { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ids: [], monster_template_ids: [],
            enchantment_template_ids: [...new Set([...selected, ...inventoryCreationSizeTemplateIds()])] }) });
    const data: unknown = await response.json();
    if (!response.ok || !fromBaseRecord(data) || !fromBaseRecord(data.base) || !fromBaseRecord(data.shared))
        throw new Error('timed-finish:yield-template-not-held');
    const sources = mergeInventoryMetadata(data.shared, data.base);
    // A fresh SELECT replaces yesterday's candidates, including deleted relations. No provisional mint is adopted here.
    encounter.inventory_yield_templates = { enchantment_templates: sources.enchantment_templates,
        enchantment_template_enchantments: sources.enchantment_template_enchantments };
}
